import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Rest from "../../Generated/RestClient";
import {ControllerBase} from "./ControllerBase";
import {BotCodeSetup, BotCodeSetupProps, BotCodeSetupState} from "../Views/index";
import {DevPortalAppBase} from "../../DevPortalAppBase";

export class BotCodeSetupController extends ControllerBase {
  private state: BotCodeSetupState;
  component: BotCodeSetup;

  constructor(app: DevPortalAppBase, containerController?: ControllerBase) {
    super(app);
    this.containerController = containerController;
  }

  public load(params: SimpleMvc.QueryParams): void {
    super.load(params);
  }

  private renderPage()  {
    let element = React.createElement(BotCodeSetup, {
      scmType: null,
      ciProps: null,
      setCodeSetup: null,
      setLoading: null,
      onScmTypeChange: null
    });
    this.component = ReactDOM.render<BotCodeSetupProps, BotCodeSetup>(element, this.pageContent);
  }

  protected render(params: SimpleMvc.QueryParams) {
    super.render(params);
    this.renderPage();
  }
}


// WEBPACK FOOTER //
// ./Client/v4/Controllers/BotCodeSetupController.ts